import React from "react";

const Breakfast = () => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      data-bbox="6.3 27 187.7 145"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="6.3 27 187.7 145"
      role="img"
      className="content-card__svg"
    >
      <g>
        <path
          d="M176.1,70l-6.1,0v-8H58v35.8c0,2.8,0.8,5.4,1.2,8.1c-17.6,3-26.4,13.5-26.8,14.1c-0.6,0.8-0.6,1.8-0.1,2.6l1.1,1.9
		c-12.2,3-16.9,13.1-17.1,13.6c-0.4,0.9-0.2,1.9,0.5,2.6l1.7,1.7c-6.1,6.6-10.9,15.3-11.1,15.7c-1.7,3-1.4,7.6,0.7,10.3l0.4,0.5
		c1.5,2,3.9,3.1,6.3,3.1c1.2,0,2.5-0.3,3.6-0.9c0.1,0,6.9-3.7,20.6-8.4l2.7,2.7c0.4,0.4,1,0.7,1.6,0.7c0.2,0,0.3,0,0.5-0.1l13.2-2.8
		l0.4,0.6c0.4,0.7,1.2,1.1,2,1.1h18.2c0.8,0,1.6-0.4,2-1.1l1-1.7l13.1,2.8c0.2,0,0.3,0.1,0.5,0.1c0.6,0,1.2-0.2,1.6-0.7l2.6-2.6
		c13.3,4.5,20.3,8.3,20.4,8.3c1.1,0.6,2.4,0.9,3.6,0.9c2.4,0,4.8-1.1,6.3-3.1l0.4-0.5c2-2.8,2.3-7.3,0.7-10.3
		c-0.1-0.2-1.4-2.2-3.5-5.4C147,146,165,129,170,109h6c10,0,18-9.5,18-19.5S185,70,176.1,70z M62,66h104v15H62V66z M16,166.9
		c-1.2,0.7-3,0.3-3.9-0.9l-0.4-0.5c-1-1.3-1.1-3.9-0.3-5.3c0.1-0.1,4.7-8.5,10.4-14.7l13.4,13.4C22.6,163.4,16.3,166.8,16,166.9z
		 M43.9,161.2l-22.6-22.7c1.6-2.7,6.1-8.4,14.6-9.9L54.3,159L43.9,161.2z M76.1,159.9H60.5l-23.4-38.5c3.1-3.2,13.1-11.8,31.2-11.8
		c18.2,0,28.1,8.5,31.2,11.7L76.1,159.9z M93.3,160L83,157.9l18.4-30.4c8.5,1.5,12.9,7.2,14.5,9.9L93.3,160z M125.2,164.4l-0.4,0.5
		c-0.8,1.1-2.6,1.5-3.9,0.9c-0.3-0.2-6.7-3.6-18.9-7.9l13.3-13.4c5.6,6.2,10.2,14.5,10.2,14.5C126.3,160.6,126.1,163.1,125.2,164.4z
		 M123.2,147.9c-1.4-1.9-3.2-4.8-4.8-6.6l1.9-1.8c0.7-0.7,0.9-1.7,0.5-2.6c-0.2-0.5-4.8-10.5-17-13.6l0.5-0.8
		c0.5-0.8,0.4-1.9-0.1-2.6c-0.5-0.6-11.6-14.9-35.9-14.9c-1.7,0-3.7,0.1-5.3,0.2c-0.4-2.5-1-4.9-1-7.5V85h104v20
		C166,119,148.4,142.9,123.2,147.9z M176,104h-6V75h6c7.4,0,13,7.4,13,14.7C189,97.1,183.4,103.7,176,104z"
        ></path>
        <path
          d="M128,55c0,0,0-2.2,0-3c0-5.2,1.3-7.6,2.9-10.4c2.1-3.4,3.8-6.7,3.8-12.6c0-1-0.9-1.9-1.9-1.9S131,28,131,28.9
		c0,5.2-1.5,7.8-3.2,10.6c-2.1,3.4-3.8,6.9-3.8,12.8c0,0.8,0,2.6,0,2.6H128z"
        ></path>
        <path
          d="M116,55c0,0,0-1.9,0-2.7c0-5.2,1.5-8,3.2-10.8c2.1-3.4,3.8-6.7,3.8-12.6c0-1-0.9-1.9-1.9-1.9s-1.9,0.9-1.9,1.8
		c0,5.2-1.5,7.8-3.2,10.6C114,42.8,112,46.1,112,52c0,0.8,0,3,0,3H116z"
        ></path>
        <path
          d="M104,55c0,0,0-2.3,0-3c0-5.2,2.2-7.4,3.8-10.2c2.1-3.4,3.8-6.7,3.8-12.6c0-1-0.9-1.9-1.9-1.9s-1.9,0.9-1.9,1.8
		c0,5.2-1.5,7.8-3.2,10.6c-2.1,3.4-4.7,6.3-4.7,12.2c0,1.3-0.1,1.3,0,3H104z"
        ></path>
      </g>
    </svg>
  );
};

export default Breakfast;
